export const REDIRECT_AT = {
  '/unser-gemuese/erbsen-und-mohrchen': '/unser-gemuese/grungemuse'
}